import { graphql } from '~/lib/graphql'

/** @deprecated overfetch のもとなので新規の利用はしないでください */
export const RestaurantSummary = graphql(`
  fragment RestaurantSummary on Restaurant {
    name
    genre {
      displayName
    }
    ...RestaurantGenre
    isCasual
    paypayAvailable
    pointAvailable
    ...RestaurantArea
    supportsInventoryNotification
    catchphraseText
    introductionText
    lunchReferencePriceRange {
      lower
      upper
    }
    dinnerReferencePriceRange {
      lower
      upper
    }
    ...RestaurantRating
    areaReviewRanking {
      ...RestaurantAreaReviewRankingItem
    }
    isReviewHidden
  }
`)
